<template>
  <div>
    <h1 class="md-title" v-if="responses.length > 0">Responses</h1>
    <v-sheet v-for="(response, i) in responses" :key="i">
      <base-learning-response-complete
        :response="response"
      ></base-learning-response-complete>
    </v-sheet>
  </div>
</template>

<script>
import BaseLearningResponseComplete from "@/components/BaseLearningResponseComplete"
export default {
  props: {
    responses: { type: Array, default: [] }
  },
  components: { BaseLearningResponseComplete }
}
</script>
